export default __webpack_public_path__ + "static/media/img-0439-hungary-premium-face.46c0afc6.png";